function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-hi-dark_svg__a",
  x1: 90.95,
  y1: 120.85,
  x2: 148.36,
  y2: 178.27,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("symbol", {
  id: "security-hi-dark_svg__b",
  "data-name": "Security_ic_hi",
  viewBox: "0 0 192.02 192"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Bounding Box",
  fill: "none",
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136 76h-8V56a32 32 0 00-64 0v20h-8V56a40 40 0 0180 0z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136 76h-8V56a32 32 0 00-64 0v20h-8V56a40 40 0 0180 0z",
  fill: "#e60000"
}), /*#__PURE__*/React.createElement("rect", {
  x: 31.83,
  y: 72,
  width: 128.17,
  height: 104,
  rx: 16,
  ry: 16,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M.02 0h192v192H.02z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 22a32 32 0 00-32 32v2a32 32 0 0164 0v-2a32 32 0 00-32-32z",
  opacity: 0.12
}), /*#__PURE__*/React.createElement("path", {
  d: "M144 174H47.83a16 16 0 01-16-16v2a16 16 0 0016 16H144a16 16 0 0016-16v-2a16 16 0 01-16 16z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 107.36a9.81 9.81 0 019.74 8.7c0-.3.07-.59.07-.89a9.81 9.81 0 10-19.62 0c0 .3 0 .6.07.89a9.81 9.81 0 019.74-8.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 105.36a9.81 9.81 0 014 18.76V148a4 4 0 01-8 0v-23.88a9.81 9.81 0 014-18.76m0-4a13.8 13.8 0 00-8 25.06V148a8 8 0 0016 0v-21.58a13.8 13.8 0 00-8-25.06z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.83 115.17a9.81 9.81 0 10-13.81 9V148a4 4 0 108 0v-23.88a9.8 9.8 0 005.81-8.95z",
  fill: "#4a4d4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 105.36a9.81 9.81 0 014 18.76V148a4 4 0 01-8 0v-23.88a9.81 9.81 0 014-18.76m0-4a13.8 13.8 0 00-8 25.06V148a8 8 0 0016 0v-21.58a13.8 13.8 0 00-8-25.06z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.07 105.73a13.77 13.77 0 01-2.07 20.69V148a8 8 0 01-11.71 7.08L114 176h30a16 16 0 0016-16v-3z",
  fill: "url(#security-hi-dark_svg__a)",
  opacity: 0.2
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Security_ic"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "Security_ic_hi",
  width: 192.02,
  height: 192,
  xlinkHref: "#security-hi-dark_svg__b"
}));

var SvgSecurityHiDark = function SvgSecurityHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgSecurityHiDark;